import { useEffect, useState } from "react";
import { Gauge, Loader2 } from "lucide-react";
import { http, fmtNum } from "../../lib/api";

const ST = { ok: ["Cumple", "text-emerald-700"], cond: ["Condición", "text-amber-700"], exc: ["Excepción", "text-orange-600"], fail: ["No cumple", "text-red-700"] };

export const MotorPanel = () => {
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const c = await http.get("/motor/ejemplo/novastar");
      const r = await http.post("/motor/evaluate", { case: c.data });
      setRes(r.data);
    } finally {
      setBusy(false);
    }
  };
  useEffect(() => { run(); }, []);
  if (!res) return null;
  const y = res.proj.years;
  return (
    <section className="panel p-6 lg:p-8" data-testid="motor-panel">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <p className="eyebrow">Motor de crédito</p>
          <h2 className="panel-title mt-1 text-xl sm:text-2xl">Caso Novastar · score y política</h2>
          <p className="mt-2 text-sm text-zinc-500">Score, política y semáforos con un caso de ejemplo, sin crear deal.</p>
        </div>
        <button data-testid="motor-run-button" onClick={run} className="btn-ghost flex items-center gap-2 border border-zinc-300 px-4 py-2 text-sm">
          {busy ? <Loader2 size={15} className="animate-spin" /> : <Gauge size={15} />} Reevaluar
        </button>
      </div>
      <div className="stagger mt-6 grid grid-cols-2 gap-6 lg:grid-cols-5">
        {[["Dictamen", res.rec, "motor-rec"], ["Score", `${res.score.total}/100 · ${res.score.band}`, "motor-score"], ["Tasa", `${res.rate.toFixed(2)}%`, "motor-rate"],
          ["DSCR año 1 / 2", y.map((v) => `${v.dscr.toFixed(2)}x`).join(" / "), "motor-dscr"], ["Monto recomendado", fmtNum(res.montoRecTotal), "motor-monto"]].map(([l, v, t]) => (
          <div key={l} className="border-t-2 border-orange-500 pt-3" data-testid={t}><p className="eyebrow">{l}</p><p className="font-serif-display mt-1 text-xl font-bold">{v}</p></div>
        ))}
      </div>
      <p className="mt-4 text-sm text-zinc-600" data-testid="motor-route">Resuelve: {res.route}</p>
      <div className="mt-6 grid gap-8 lg:grid-cols-2">
        <table className="w-full text-sm" data-testid="motor-score-table">
          <thead><tr className="bg-[#111] text-left text-[10px] uppercase tracking-wider text-white"><th className="px-3 py-2">Factor</th><th className="px-3 py-2">Detalle</th><th className="px-3 py-2 text-right">Pts</th></tr></thead>
          <tbody>{res.score.F.map((f) => (
            <tr key={f.key} className="row-hover border-b border-zinc-100"><td className="px-3 py-1.5 font-semibold">{f.name}</td><td className="px-3 py-1.5 text-xs text-zinc-600">{f.detail}</td><td className="px-3 py-1.5 text-right tabular-nums">{f.pts}/{f.max}</td></tr>))}
          </tbody>
        </table>
        <table className="w-full text-sm" data-testid="motor-gates-table">
          <thead><tr className="bg-[#111] text-left text-[10px] uppercase tracking-wider text-white"><th className="px-3 py-2">Criterio</th><th className="px-3 py-2">Resultado</th></tr></thead>
          <tbody>{res.gates.map((g) => (
            <tr key={g.key} className="row-hover border-b border-zinc-100" title={g.detail}><td className="px-3 py-1.5">{g.name}</td><td className={`px-3 py-1.5 font-semibold ${ST[g.status][1]}`} data-testid={`motor-gate-${g.key}`}>{ST[g.status][0]}</td></tr>))}
          </tbody>
        </table>
      </div>
    </section>
  );
};
